export default "__VITE_ASSET__fC8Mf6y8__"